import axios from 'axios';
import { DropboxError } from '../errors';
import { Dropbox } from 'dropbox';

const DROPBOX_TOKEN_KEY_NAME = 'dbxToken';
const DROPBOX_CLIENT_ID = process.env.REACT_APP_DROPBOX_CLIENT_ID;

export async function getDropBoxFileContents(fileId, accessToken, role) {
  if (!accessToken) throw new DropboxError('access_token is not exist', 401);
  try {
    const dbx = new Dropbox({
      clientId: DROPBOX_CLIENT_ID,
      accessToken: accessToken
    });

    const currentInfo = await dbx.usersGetCurrentAccount();
    dbx.pathRoot = JSON.stringify({
      '.tag': 'namespace_id',
      namespace_id: currentInfo.result.root_info.root_namespace_id
    });

    const fileInfo = await dbx.filesDownload({ path: fileId });

    return new File([fileInfo.result.fileBlob], fileInfo.result.name);
  } catch (error) {
    const errMessage = error.error.error_summary ? error.error.error_summary : error.message;
    throw new DropboxError(errMessage, error.status);
  }
}

export async function uploadContents(fileId, token, fileData) {
  try {
    const result = await axios({
      url: 'https://content.dropboxapi.com/2/files/upload',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/octet-stream',
        'Dropbox-API-Arg': JSON.stringify({ path: fileId, mode: { '.tag': 'overwrite' } })
      },
      data: fileData //new File([arg.blob], arg.name)
    });
    return result;
  } catch (error) {
    throw new Error(error);
  }
}

export function getDropboxAuthToken() {
  return window.localStorage.getItem(DROPBOX_TOKEN_KEY_NAME);
}
export function setDropboxAuthToken(token) {
  window.localStorage.setItem(DROPBOX_TOKEN_KEY_NAME, token);
}

export function initDropboxAuthTokenInfo() {
  window.localStorage.clear();
  window.sessionStorage.clear();
}
